import { getStorage } from "@/utils/storage";
const LANGUAGE = getStorage("LANGUAGE");
(function () {
  LANGUAGE == "th" ? import("./font-th.module.less") : import("./font.module.less");
})();
